/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { initializeApp } from "firebase/app";
import { collection, getFirestore, addDoc, Timestamp } from "firebase/firestore";

import { options, tab_couleurs, tab_env, tab_modeles, tab_secu } from "./Correspondances";
import { ConvSecu } from "./Fonctions";

const firebaseConfig = {
	apiKey: "AIzaSyAm-Os2-zgIL7ERS4x9_96XzXzrNSwslgc",
	authDomain: "configurateur-store-vision.firebaseapp.com",
	projectId: "configurateur-store-vision",
	storageBucket: "configurateur-store-vision.appspot.com",
	messagingSenderId: "607556892215",
	appId: "1:607556892215:web:d21ac7fa00903f5b43b1b2"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export async function SendConfig(store_type, commande, compas, securite, largeur, hauteur, couleur, environnement, computeenv, contacts, HorsNormes, orientation, prix) {
	const collectionRef = collection(db, "demandes");

	let demande = {
		date: Timestamp.now(), // timestamp Firebase
		configurateur: 'public',
		configuration: {
			store_type: tab_modeles[store_type],
			commande: options[commande],
			largeur: parseInt(largeur),
			hauteur: parseInt(hauteur),
			orientation: compas,
			couleur: store_type ? "N/A" : tab_couleurs[couleur],
			environnement: tab_env[environnement-1],
			securite: tab_secu[ConvSecu(securite, computeenv, orientation)[0]],
			verre_int: ConvSecu(securite, computeenv, orientation)[1],
			verre_ext: ConvSecu(securite, computeenv, orientation)[2],
			HorsNormes: HorsNormes,
			prix_public_ttc: prix
		},
		contact: {
			prenom: contacts.prenom,
			nom: contacts.nom,
			codepostal: contacts.codepostal,
			email: contacts.email
		}
	};

	const docRef = await addDoc(collectionRef, demande);
}
